module.exports = __webpack_public_path__ + "static/img/role-kehu.588f75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role-kehu.png
// module id = T2vH
// module chunks = 7